module.exports = __webpack_public_path__ + "static/media/vigo-panel-logo.4a934986.svg";